export default __webpack_public_path__ + "static/media/toy-robotic-arm@3x.304683c7.png";